import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import {
  Card,
  Grid,
  MenuItem,
  Select,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

export default class JobApplicationDetails extends Component {
  state = {
    loading: false,
    applicant: null,
    status: "",
    notification: false,
    notiColor: "success",
    message: "",
  };

  componentDidMount() {
    if (init() !== "success") return window.location.assign("/signin");

    const applicantId = window.location.pathname.split("/")[2];
    this.fetchApplicantDetails(applicantId);
  }

  /* =========================
     FETCH DETAILS
  ========================= */
  fetchApplicantDetails = async (id) => {
    this.setState({ loading: true });

    try {
      const res = await axios.get(
        `${Constants.getUrls.getAllJobApplications}/${id}`
      );

      this.setState({
        applicant: res.data?.data,
        status: res.data?.data?.status || "applied",
        loading: false,
      });
    } catch (err) {
      this.setState({
        loading: false,
        notification: true,
        notiColor: "warning",
        message: "Failed to load application details",
      });
    }
  };

  /* =========================
     UPDATE STATUS
  ========================= */
  updateStatus = async () => {
    const { applicant, status } = this.state;

    try {
      await axios.patch(
        `${Constants.patchUrls.updateApplicantStatus}${applicant._id}`,
        { status }
      );

      this.setState({
        notification: true,
        notiColor: "success",
        message: "Status updated successfully",
      });
    } catch {
      this.setState({
        notification: true,
        notiColor: "warning",
        message: "Failed to update status",
      });
    }
  };

  /* =========================
     RENDER
  ========================= */
  render() {
    const { applicant, loading, status } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Job Application Details
              </MDTypography>
            </MDBox>

            <MDBox p={4}>
              {loading ? (
                <MDTypography>Loading...</MDTypography>
              ) : applicant ? (
                <Grid container spacing={3}>
                  
                  {/* PERSONAL INFO */}
                  <Grid item xs={12} md={6}>
                    <MDTypography variant="h6">Applicant Information</MDTypography>
                    <Info label="Full Name" value={applicant.full_name} />
                    <Info label="Email" value={applicant.email} />
                    <Info label="Mobile" value={applicant.mobile} />
                    <Info label="Availability" value={applicant.availability} />
                  </Grid>

                  {/* JOB INFO */}
                  <Grid item xs={12} md={6}>
                    <MDTypography variant="h6">Job Information</MDTypography>
                    <Info
                      label="Job Title"
                      value={applicant.career_id?.job_title}
                    />
                    <Info
                      label="Location"
                      value={applicant.career_id?.job_location}
                    />
                    <Info
                      label="Category"
                      value={applicant.category_id?.name}
                    />
                  </Grid>

                  {/* EXPERIENCE */}
                  <Grid item xs={12}>
                    <MDTypography variant="h6">Experience</MDTypography>
                    <MDTypography variant="body2">
                      {applicant.experience}
                    </MDTypography>
                  </Grid>

                  {/* COVER LETTER */}
                  {applicant.cover_letter && (
                    <Grid item xs={12}>
                      <MDTypography variant="h6">Cover Letter</MDTypography>
                      <MDTypography variant="body2">
                        {applicant.cover_letter}
                      </MDTypography>
                    </Grid>
                  )}

                  {/* RESUME */}
                  <Grid item xs={12}>
                    <MDTypography variant="h6">Resume</MDTypography>
                    <MDButton
                      variant="outlined"
                      color="info"
                      href={`${Constants.baseUrl}${applicant.resume}`}
                      target="_blank"
                    >
                      Download Resume
                    </MDButton>
                  </Grid>

                  {/* STATUS */}
                  <Grid item xs={12} md={4}>
                    <MDTypography variant="h6">Application Status</MDTypography>
                    <Select
                      fullWidth
                      value={status}
                      onChange={(e) =>
                        this.setState({ status: e.target.value })
                      }
                      style={{ height: "45px" }}
                    >
                      <MenuItem value="applied">Applied</MenuItem>
                      <MenuItem value="in_review">In Review</MenuItem>
                      <MenuItem value="interview_scheduled">
                        Interview Scheduled
                      </MenuItem>
                      <MenuItem value="offered">Offered</MenuItem>
                      <MenuItem value="rejected">Rejected</MenuItem>
                    </Select>

                    {/* <MDButton
                      color="info"
                      sx={{ mt: 2 }}
                      onClick={this.updateStatus}
                    >
                      Update Status
                    </MDButton> */}
                  </Grid>
                </Grid>
              ) : (
                <MDTypography>No application found</MDTypography>
              )}
            </MDBox>
          </Card>
        </MDBox>

        <MDSnackbar
          color={this.state.notiColor}
          icon="notifications"
          title="Job Applications"
          content={this.state.message}
          open={this.state.notification}
        />
      </DashboardLayout>
    );
  }
}

/* =========================
   INFO ROW
========================= */
function Info({ label, value }) {
  return (
    <MDBox mb={1}>
      <MDTypography variant="button" fontWeight="bold">
        {label}:
      </MDTypography>{" "}
      <MDTypography variant="body2" component="span">
        {value || "-"}
      </MDTypography>
    </MDBox>
  );
}
